import { getEnvValue } from '@shared/helpers';
import { createInstance, HttpClient } from '@shared/http';

const feedbackInstance = createInstance({
  baseURL: getEnvValue('FEEDBACK_API_URL'),
});
export const feedbackClient = new HttpClient(feedbackInstance);
